export default "__VITE_ASSET__69c58542__"